<template>
  <div class="home">
    <topinfo></topinfo>
    <tabs ref="tabs" :iteminfo="iteminfo" @ispage="ispage"></tabs>
    <botinfo></botinfo>

  </div>
</template>

<script>
import topinfo from 'components/topinfo/topinfo'
import botinfo from 'components/botinfo/botinfo'

import tabs from './child/tabs.vue'

import {gethome} from 'network/home'

export default {
  components:{topinfo,botinfo,tabs},
  data () {
    return {
      iteminfo:[{quest:[],pc:[],jc:[],oculusset:[],soso:[]},{quest:2,pc:2,oculusset:2}]
    }
  },
  created() {
    gethome('','quest','1').then(res => {
      this.iteminfo[0]['quest'].push(...res.data.msg)
    })
    gethome('','pc','1').then(res => {
      this.iteminfo[0]['pc'].push(...res.data.msg)
    })
    gethome('','oculusset','1').then(res => {
      this.iteminfo[0]['oculusset'].push(...res.data.msg)
    })
    this.$bus.$on('soso',(res,about)=>{
      this.iteminfo[0]['soso'] = []
      gethome(res,about,'1').then(res =>{
        this.iteminfo[0]['soso'].push(...res.data.msg)
        this.$refs.tabs.activeName = 'soso'
      })

    })
  },
  methods:{
    ispage(info){
      gethome(info['name'],info['pagename'],this.iteminfo[1][info['pagename']]).then(res => {
        this.iteminfo[0][info['pagename']].push(...res.data.msg)
        this.iteminfo[1][info['pagename']]++
      })
    }
  },
}
</script>

<style scoped>
.home{
  width: 1300px;
  background-color: #f8f8f8;
  height: 100%;
  margin: 0 auto;
  box-shadow: 0px 0px 5px 5px #c0c0c0;


}
</style>
